import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnergyDisabled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_14800_12642)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.61211 0.511185C6.75855 0.484105 6.9098 0.501481 7.04571 0.560013L7.10235 0.587357L7.15703 0.619583C7.26335 0.688641 7.35027 0.784105 7.40996 0.895951L7.43828 0.952591L7.46075 1.01216C7.50732 1.15244 7.51091 1.30428 7.47149 1.44771C7.46975 1.45407 7.46861 1.46096 7.46661 1.46724L6.50664 4.47701L6.49786 4.50044H9.99981C10.1884 4.50012 10.3733 4.55259 10.533 4.65279C10.6933 4.75339 10.8215 4.89813 10.9031 5.0688C10.9847 5.23944 11.0171 5.42979 10.9949 5.61763C10.9727 5.80545 10.8973 5.98344 10.7781 6.13033C10.7688 6.14177 10.7591 6.15295 10.7488 6.16353L5.79864 11.2631H5.79766C5.6884 11.3799 5.5452 11.4595 5.3875 11.4887C5.22027 11.5196 5.04725 11.4927 4.89727 11.4126C4.74733 11.3323 4.62847 11.2035 4.56133 11.0473C4.49429 10.8911 4.48303 10.7162 4.52813 10.5522L4.53301 10.5327L5.49297 7.5229L5.50176 7.50044L1.99981 7.49947C1.81138 7.49974 1.62626 7.44725 1.46661 7.34712C1.30656 7.24663 1.17816 7.10249 1.09649 6.93208C1.0148 6.76139 0.982484 6.57021 1.00469 6.38228C1.02694 6.19447 1.10234 6.01646 1.22149 5.86958C1.23076 5.85817 1.24054 5.84694 1.25078 5.83638L6.20098 0.736771C6.3103 0.619797 6.45421 0.54044 6.61211 0.511185Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_14800_12642",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 12,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgEnergyDisabled);
export default ForwardRef;
